module.exports = __webpack_public_path__ + "static/media/user-pink.f75b3868.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/user-pink.svg
// module id = 117
// module chunks = 0